var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5,29.8v6.7c0,1.7,1.3,3,3,3h31c1.7,0,3-1.3,3-3v-20c0-1.7-1.3-3-3-3h-1.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7,13.5h-9.2l-4.9-4.1c-0.7-0.6-1.6-0.9-2.6-0.9H8.5c-1.7,0-3,1.3-3,3v11.7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6,16.5h12.1c0.9,0,1.8-0.3,2.6-0.9l2.3-1.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectIcon);
export default __webpack_public_path__ + "static/media/project-icon.9dae3f8e299644d5b745463a726b1f07.svg";
export { ForwardRef as ReactComponent };